import { List, MenuItem, Select, styled } from "@mui/material";
import { Poppins } from "next/font/google";

const poppins = Poppins({
  weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
  subsets: ["latin"],
  display: "swap",
});

export const StyledSelect = styled(Select)(({ theme }) => ({
  fontFamily: poppins.style.fontFamily,
  borderRadius: "8px",
  "& .MuiSelect-select.MuiSelect-outlined": {
    fontSize: "16px",
    fontWeight: 500,
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  "&.MuiButtonBase-root.MuiMenuItem-root": {
    display: "flex",
    gap: "8px",
    alignItems: "center",
  },
}));

export const StyledList = styled(List)(({ theme }) => ({
  margin: "16px 0px !important",
  "& .MuiListItemIcon-root": {
    color: "#001233",
  },
  "& .MuiListItemText-root": {
    color: "#001233",
    fontSize: "16px",
    fontWeight: 500,
  },
}));
